import { Button, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const CustomButton = styled(Button)({
  backgroundColor: `${colors.primary} !important`,
  borderRadius: "10px !important",
  "&:hover": {
    backgroundColor: `${colors.primaryHover} !important`,
  },
});
